<template>
  <div v-if="client">
    DevOps mode
    <el-switch
      inactive-color="#f0f0f0"
      active-color="#ff4949"
      :value="devops"
      :disabled="!client.team"
      @change="change"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState(['client', 'devops']),
  beforeMount () {
    if (this.client) {
      this.getValue(this.client.id)
    }
  },
  methods: {
    change (devops) {
      this.$store.commit('init', { devops })
      localStorage.setItem('devops:' + this.client.id, devops)
    },
    getValue (clientId) {
      const devops = this.client.team && !!localStorage.getItem('devops:' + clientId)
      this.$store.commit('init', { devops })
    }
  },
  watch: {
    'client.team' (value) {
      if (!value) {
        this.$store.commit('init', { devops: false })
      }
    },
    'client.id' (value) {
      if (value) {
        this.getValue(value)
      }
    }
  }
}
</script>
